import { debounce } from 'lodash'

export default {
  data() {
    return {
      windowSize: document.body.clientWidth
    }
  },
  computed: {
    isFullScreen() {
      return this.windowSize < 736
    }
  },
  mounted() {
    this.onWindowResize()
  },
  methods: {
    onWindowResize() {
      window.addEventListener(
        'resize',
        debounce(event => {
          this.windowSize = document.body.clientWidth
        }, 500)
      )
    }
  }
}
